import {
    createContext,
    useState,
    useContext,
    useCallback,
} from "react";
import { changeMemberRoleAPICall, getMembersAPICall, inviteMembersAPICall, removeMemberAPICAll } from "../api/members/membersServive";


export const MembersContext = createContext({
    memberCounts: null,
    getMembersList: () => { },
    inviteMembers: () => { },
    deleteMember: () => { },
    changeMemberRole: () => { }


});

const MembersContextProvider = ({ children, setLoading }) => {
    const [memberCounts, setMemberCounts] = useState(null);

    const getMembersList = useCallback(async (projectId, page, itemsPerPage, search, onSuccess, onError, role) => {
        getMembersAPICall(
            projectId,
            page,
            itemsPerPage,
            search,
            function (response) {
                if (response.data.counts) setMemberCounts(response.data.counts);
                onSuccess(response);
            },
            onError,
            role
        );
    });

    const inviteMembers = useCallback(async (projectId, members, onSuccess, onError) => {
        inviteMembersAPICall(
            projectId,
            members,
            function (response) {
                onSuccess(response);
            },
            onError
        );
    });

    const deleteMember = useCallback(async (projectId, memberId, onSuccess, onError) => {
        removeMemberAPICAll(
            projectId,
            memberId,
            function (response) {
                onSuccess(response);
            },
            onError
        );
    });

    const changeMemberRole = useCallback(async (projectId, memberId, role, productSlugs, onSuccess, onError) => {
        changeMemberRoleAPICall(
            projectId,
            memberId,
            role,
            productSlugs,
            function (response) {
                onSuccess(response);
            },
            onError
        );
    });


    return (
        <MembersContext.Provider
            value={{
                memberCounts,
                getMembersList, inviteMembers, deleteMember, changeMemberRole
            }}
        >
            {children}
        </MembersContext.Provider>
    );
};

export const useMembersContext = () => useContext(MembersContext);

export default MembersContextProvider;
